module.exports = __webpack_public_path__ + "img/HeadExtraction02.4da3afdd.png";